import { Fragment, h } from 'preact';

import { getLabel } from '../../../../labels/labelling-service';
import { RESPONSIVE_OFFSETS } from '../../../../utils/constants';
import { scrollToElement } from '../../../../utils/dom-utils';
import SkyItPanel from '../../../components/3-molecules/sky-it-panel/sky-it-panel';
import SkyItContentSlider from '../../../components/4-organisms/sky-it-content-slider/sky-it-content-slider';
import { formatDate } from '../helpers/date';
import { satelliteTracker } from '../../../../services/tracking/satellite-tracking-service';
import { EDIT_PAGE_VIEW_EVENT } from '../../../../utils/analytics';

export const renderYourContents = ({ pageHandlers, allContentsByUserPreferences, selectedTab, pageActions, data }) => {
  const isYourContentsTabSelected = selectedTab === 1;

  const getIntcmpCardSlider = (userPreference) => {
    return userPreference.config.preferencesPage.intCmp.cardContentLink;
  };
  const getIntcmpGoToSection = (userPreference) => {
    return userPreference.config.preferencesPage.intCmp.ctaGoToPreference;
  };
  const getIntcmpEdit = (userPreference) => {
    return userPreference.widgetConfig.ctaEditPreference;
  };
  const handlePrimaryClick = () => {
    pageHandlers.handlePanelNoDataClick();
    satelliteTracker.trackInWeb(EDIT_PAGE_VIEW_EVENT, {
      pagename: `${window.digitalData.page.pageInfo.pageName}:personalizza`,
      intcmp: data.intCmp,
    });
  };

  if (!allContentsByUserPreferences.length) {
    return (
      <SkyItPanel
        title={data.title}
        description={data.description}
        ctaPrimaryLabel={data.ctaLabel}
        onCtaPrimaryClick={handlePrimaryClick}
        intcmpCta={data.intCmp}
      />
    );
  }

  return (
    isYourContentsTabSelected && (
      <Fragment>
        {allContentsByUserPreferences.map((userPreference) => (
          <SkyItContentSlider
            key={userPreference.id}
            title={userPreference.name}
            image={userPreference.config.urlLogoOnWhiteBack || userPreference.config.urlLogo}
            intcmpCard={getIntcmpCardSlider(userPreference)}
            slides={userPreference.contents.map((content) => ({
              ...content,
              time: formatDate(content.date),
              abstract: content.abstractText,
            }))}
            boxOptions={[
              {
                text: getLabel('contents.dropdown.option.go.to.section'),
                intcmp: getIntcmpGoToSection(userPreference),
                hasArrow: true,
                href: userPreference.config.linkCta,
              },
              {
                text: getLabel(`contents.dropdown.option.edit.${userPreference.htmlId}`),
                hasArrow: true,
                onClick: () => {
                  pageActions.selectTab(2);
                  satelliteTracker.trackInWeb(EDIT_PAGE_VIEW_EVENT, {
                    pagename: `${window.digitalData.page.pageInfo.pageName}:personalizza`,
                    intcmp: getIntcmpEdit(userPreference),
                  });
                  const responsiveOffset = RESPONSIVE_OFFSETS.default;
                  const $element = document.getElementById(`${userPreference.htmlId}InPage`);
                  scrollToElement({ $element, top: true, responsiveOffset, delay: 250 });
                },
              },
            ]}
          />
        ))}
      </Fragment>
    )
  );
};
